import React from 'react'

import EarningsContainer from 'Pods/Profile/Dashboard/MyStatisctics/Components/EarningsContainer'

import CustomRoyaltyBox from './CustomRoyaltyBox'
import DefaultRoyaltyBox from './DefaultRoyaltyBox'
import useEarningsOverview from '../../../Hooks/useEarningsOverview'

function getRoyaltyBox(isDataFetched, data) {
  if (!isDataFetched) return null
  if (data?.custom_royalty_rate) {
    return <CustomRoyaltyBox levelRoyaltyRate={data?.royalty_rate || 0} />
  }

  return (
    <DefaultRoyaltyBox
      annualRevenue={data.annual_revenue}
      levelRoyaltyRate={data?.royalty_rate || 0}
      levelId={data?.level_id || 0}
      nextLevelRoyaltyRate={data?.next_level_royalty_rate || 0}
      nextLevelGmvThreshold={data?.next_level_gmv_threshold || 0}
    />
  )
}

function LegacyOverviewTab() {
  const {
    data,
    earningsScope,
    isDataFetched,
    onSortChange,
  } = useEarningsOverview(12)

  return (
    <div className="row">
      <div className="col-12">
        <div className="card--flat dashboard-card dashboard-card--earnings">
          <EarningsContainer
            isDataFetched={isDataFetched}
            data={data}
            earningsScope={earningsScope}
            onSortChange={onSortChange}
          />
        </div>

        {getRoyaltyBox(isDataFetched, data)}
      </div>
    </div>
  )
}

export default LegacyOverviewTab
